import { useQuery } from '@apollo/client';

import { useParams } from 'js/lib/useRouter';

import specializationReviewsPageQuery from 'bundles/reviews/queries/SpecializationReviewsPage.graphql';
import type {
  SpecializationReviewsPageDataFragment,
  SpecializationReviewsPageQuery,
  SpecializationReviewsPageQueryVariables,
} from 'bundles/reviews/queries/__generated__/SpecializationReviewsPage';

export type SpecializationReviewsPageData = SpecializationReviewsPageDataFragment;

type SpecializationReviewsPageQueryResult = {
  loading: boolean;
  error?: Error;
  reviewsPageData: SpecializationReviewsPageData | null;
};

/**
 * Fetches the real topReviews/ratingCountsByStar for the specialization reviews page via
 * DescriptionPage.querySpecializationReviewsPage.
 */
export function useSpecializationReviewsPageQuery(): SpecializationReviewsPageQueryResult {
  const params = useParams();
  const slug = params?.slug ?? '';

  const { data, loading, error } = useQuery<SpecializationReviewsPageQuery, SpecializationReviewsPageQueryVariables>(
    specializationReviewsPageQuery,
    {
      variables: { slug },
      skip: !slug,
      context: {
        clientName: 'gatewayGql',
      },
    }
  );

  return {
    loading: !!slug && loading,
    error,
    reviewsPageData: data?.DescriptionPage?.querySpecializationReviewsPage ?? null,
  };
}
